import { constants as config } from '@config';

module.exports = function (S) {
  const svgroot = S.svgroot;
  const getNextId = S.getNextId;
  const canvas = S.canvas;
  const tool = INKIVE.Tool.getInstance();
  const checkedImages = [];
  let cropCallback;
  let zoom = canvas.getZoom();

  const NS = svgedit.NS;
  const checkPath = 'M4.709151835568682,-3.6700929539934743 l-0.2701267432887881,-0.23207203150960343 c-0.4483873553311766,-0.38531938435010876 -1.122182025081978,-0.342368985325819 -1.5180538781578927,0.09661782769017971 L-1.5979126740265879,1.205003606522806 l-1.364045431081792,-1.1748003779096279 c-0.44791424269824454,-0.385751356754091 -1.1218117630214226,-0.343664902537758 -1.5181567287302533,0.09484879784530936 l-0.23883959917196104,0.2642848307778313 c-0.1936881978988181,0.21419660203062382 -0.2942554875682459,0.49674769446245304 -0.279650706290821,0.7853669706644774 c0.014748772078743543,0.2884547152862314 0.14343540823582135,0.559260272352679 0.3579611320980491,0.7528661897936226 l2.500359124808254,2.2896800123528975 c0.21647988473737814,0.20329444135874944 0.5066007792960909,0.3093128113641188 0.8031395495710801,0.293576673790562 c0.29653877027498937,-0.015694997344604666 0.5737827731722188,-0.15193086551409013 0.7674915411855078,-0.37702962821658553 l5.394409670558034,-6.267919581748893 c0.18846338882210512,-0.21898943870335394 0.2821602602568087,-0.5038443839564104 0.260438219370957,-0.7918671268386646 C5.063492627519072,-3.214218076993343 4.928264694958853,-3.4818352663160828 4.709151835568682,-3.6700929539934743 z';
  const exclamationPath = 'm0.06825971560755684,-6.1721719303542475 c-0.8114970642238094,0 -1.4682595187438967,0.4674760214406373 -1.4682595187438967,1.0281574893048238 v6.191159705442861 c0,0.5679254144774648 0.6519484888849,1.0281574893048238 1.4682595187438967,1.0281574893048238 c0.8135601923532222,0 1.4682595187438967,-0.4674760214406373 1.4682595187438967,-1.0281574893048238 v-6.191159705442861 c0,-0.5679254144774648 -0.6505730701319765,-1.0281574893048238 -1.4682595187438967,-1.0281574893048238 zm0,10.309584819952745 c-0.8114970642238094,0 -1.4682595187438967,0.46071500460161574 -1.4682595187438967,1.0310550679501227 c0,0.569857133574306 0.6560747451436653,1.0310550679501227 1.4682595187438967,1.0310550679501227 c0.8121847736002868,0 1.4682595187438967,-0.46071500460161574 1.4682595187438967,-1.0310550679501227 c0,-0.569857133574306 -0.6546993263907471,-1.0310550679501227 -1.4682595187438967,-1.0310550679501227 z';

  const placeholder = 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg';
  const placeholderSize = {
    width: 1280,
    height: 1280
  };

  // Get Image Full capacity size depends on layout
  function getFullSize (imgSize, layout) {
    const imgFullSize = {
      x: 0,
      y: 0,
      width: Math.floor4(imgSize.width * layout.height / imgSize.height),
      height: Math.floor4(imgSize.height * layout.height / imgSize.height)
    };

    if (imgFullSize.width < layout.width) {
      imgFullSize.width = Math.floor4(imgSize.width * layout.width / imgSize.width);
      imgFullSize.height = Math.floor4(imgSize.height * layout.width / imgSize.width);
      imgFullSize.y = Math.floor4((imgFullSize.height - layout.height) / 2);
    } else {
      imgFullSize.x = Math.floor4((imgFullSize.width - layout.width) / 2);
    }

    return imgFullSize;
  }

  function setLayoutBoxCoord (element, dimensions) {
    if (!dimensions) return;

    const layoutBox = typeof element === 'string'
      ? document.getElementById(element)
      : element;

    const boxCoordinates = ['x', 'y', 'width', 'height']
      .map(property => Math.floor4(dimensions[property]))
      .join(' ');

    layoutBox.dataset.boxCoordinates = boxCoordinates;

    if (!INKIVE.Helpers.elementHelper(layoutBox).isVideo()) {
      layoutBox.textContent = null;
    }
  }

  function getLayoutBoxThumbnail (layoutBox) {
    const element = typeof layoutBox === 'string'
      ? document.getElementById(layoutBox)
      : layoutBox;

    if (element.tagName === 'image') return element;

    return element.querySelector('image') || element;
  }

  function getLayoutBoxCoord (layoutBox) {
    const thumbnail = getLayoutBoxThumbnail(layoutBox);
    const getAttribute = name => Math.floor4(thumbnail.getAttribute(name));
    /* coordinates also receive thumbnail.textContent for backward compatibility */
    const coordinates = layoutBox.dataset.boxCoordinates || thumbnail.textContent;

    let arBb = coordinates.split(/[^-|\d.]/).map(attribute => Math.floor4(attribute));
    if (arBb.length < 4) {
      arBb = [
        getAttribute('x'),
        getAttribute('y'),
        getAttribute('width'),
        getAttribute('height')
      ];
    }

    const [x, y, width, height] = arBb;
    return { x, y, width, height };
  }

  function replaceHtmlEntitiesWithCharCodes (svg) {
    return svg.replace(/(&\w+;)/g, function (match) {
      const chars = $('<p>' + match + '</p>').text();
      let result = '';

      for (let i = 0; i < chars.length; i++) {
        result += '&#' + chars.charCodeAt(i) + ';';
      }

      return result;
    });
  }

  /**
   * Called from svncanvas.addElement()
   * This is the code to sets layout for defs and content
   */
  function setLayout (defs, content, triggerImagesLoading, keep) {
    canvas.clearSelection();
    INKIVE.ImagesFactory.inlinedImages = {};

    content = replaceHtmlEntitiesWithCharCodes(content);
    content = INKIVE.Helpers.imagesSanitize.preLoadImagesSanitize(content);

    let svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs>' + defs + '</defs><g>' + content + '</g></svg>';
    svg = $.parseXML(svg);

    keep && $(svg).find('image').each(function (i, image) {
      image.setAttributeNS(NS.XLINK, 'xlink:href', INKIVE.Helpers.getCORSSecureUrl(placeholder));
    });

    INKIVE.Helpers.imagesSanitize.postLoadBackgroundSanitize(svg);
    !keep && triggerImagesLoading && INKIVE.Helpers.imagesSanitize.postLoadImagesSanitize(svg);

    const svgcontent = canvas.getSvgContent();
    const currentLayer = canvas.getCurrentDrawing().current_layer;
    const $layoutDefs = $(svgcontent).find('defs');

    currentLayer.setAttribute('class', 'main');

    // Delete old defs
    if (!keep && $layoutDefs && $layoutDefs.length > 0) {
      $layoutDefs.remove();
    }

    let layoutDefs = $(svgcontent).find('#layout_defs')[0];
    if (!layoutDefs) {
      layoutDefs = document.createElementNS(NS.SVG, 'defs');
      layoutDefs.setAttribute('id', 'layout_defs');
      svgcontent.insertBefore(layoutDefs, svgcontent.childNodes[0]);
    }

    const defsElement = svg.getElementsByTagName('defs')[0];

    // Append new layout defs
    let j = defsElement.childNodes.length;
    let old = null;

    while (j) {
      const node = defsElement.childNodes[j - 1];

      switch (node.tagName) {
        case 'title':
          break;
        default:
          layoutDefs.insertBefore(node, old);
          old = node;
          break;
      }
      j--;
    }

    // Delete current content
    if (!keep) {
      j = currentLayer.childNodes.length;

      while (j) {
        const node = currentLayer.childNodes[j - 1];

        switch (node.tagName) {
          case 'title':
            break;
          default:
            currentLayer.removeChild(node);
            break;
        }
        j--;
      }
    }

    const contentElement = svg.getElementsByTagName('g')[0];
    svgedit.sanitize.sanitizeSvg(contentElement);

    // Append new layout
    j = contentElement.childNodes.length;
    old = null;

    while (j) {
      const node = contentElement.childNodes[j - 1];

      // Conversion from v1 to v2
      $(node).hasClass('element') || $(node).addClass('element');
      let nextId = INKIVE.Helpers.getUnusedId(svg);
      const clipPath = svgedit.utilities.getClipPath(node);

      switch (node.tagName) {
        case 'title':
          break;
        case 'image':
        default:
          if (node.tagName === 'image') {
            const inlinedImages = INKIVE.ImagesFactory.inlinedImages;

            while (inlinedImages[INKIVE.ImagesFactory.getImageHash(nextId)]) {
              nextId = INKIVE.Helpers.getUnusedId(svg);
            }

            const imageUrl = INKIVE.ImagesFactory.getImageUrl(node);
            delete inlinedImages[INKIVE.ImagesFactory.getImageHash(node)];

            svgedit.utilities.assignAttributes(node, { id: nextId });
            INKIVE.ImagesFactory.setImageUrl(node, imageUrl);
          } else {
            svgedit.utilities.assignAttributes(node, { id: nextId });
          }

          currentLayer.insertBefore(node, old);
          old = node;

          // update clippath ids
          if (clipPath) {
            const newId = INKIVE.Helpers.getUnusedId(svg);
            svgedit.utilities.assignAttributes(clipPath, { id: 'clip_' + newId });
            svgedit.utilities.assignAttributes(node, { 'clip-path': 'url(#clip_' + newId + ')' });
          }

          break;
      }
      j--;
    }

    INKIVE.Helpers.converterCurrentPage();
  }

  function showLayoutClipper (layout, callback) {
    cropCallback = callback;
    canvas.clearSelection();

    $('#selectorGrip_rotateconnector').hide();
    $('#selectorGrip_rotate').hide();

    const isVideo = INKIVE.Helpers.elementHelper(layout).isVideo();
    const layoutReference = getLayoutReference(layout, isVideo);
    const id = layoutReference.getAttribute('id');
    const layoutBox = canvas.copyElem(svgedit.utilities.getElem(id));
    const clipPathElem = getClipPathCopy();
    const angle = svgedit.utilities.getRotationAngle(clipPathElem);

    layoutBox.removeAttribute('clip-path');
    createLayoutOverlay();

    canvas.createLayer('clipperImage');
    const clipperImage = canvas.getCurrentDrawing().current_layer;
    clipperImage.setAttribute('class', 'clipperImage');
    layoutBox.setAttribute('id', getNextId());
    layoutBox.setAttribute('class', 'layoutClipperImage element');

    const layoutScreen = getLayoutScreen(layoutBox);
    clipperImage.appendChild(layoutBox);
    clipperImage.appendChild(layoutScreen);

    canvas.createLayer('clipperSelector');

    const clipperSelector = canvas.getCurrentDrawing().current_layer;
    clipperSelector.setAttribute('class', 'clipperSelector');
    clipperSelector.appendChild(clipPathElem);

    setTransform(clipPathElem.id, angle < -180
      ? (360 + angle)
      : angle);
    canvas.setCurrentLayer('clipperImage');
    layoutScreen.setAttribute('style', getDefaultStyleAttribute('screen'));

    $(layoutBox).on('dblclick', function (ev) {
      cropLayoutContent(layout, layoutBox, true);
      ev.preventDefault();
      ev.stopPropagation();
    });

    canvas.addToSelection([layoutBox], true);
    canvas.call('editor.cropping', true);
    toggleCanvaOverflow(true);

    function getLayoutReference (layout, isVideo) {
      if (!isVideo) return layout;

      const thumbnail = layout.querySelector('image');
      const boxCoordinates = layout.dataset.boxCoordinates || layout.textContent;

      thumbnail.dataset.boxCoordinates = boxCoordinates;
      thumbnail.textContent = boxCoordinates;

      return thumbnail;
    }

    function isBlendModeSupported () {
      if ('CSS' in window && 'supports' in window.CSS) {
        return window.CSS.supports('mix-blend-mode', 'soft-light');
      }

      return false;
    }

    function getDefaultStyleAttribute (blendMode) {
      return isBlendModeSupported()
        ? 'mix-blend-mode:' + blendMode + '; pointer-events:none;'
        : 'pointer-events:none;';
    }

    function getClipPathCopy () {
      const t = layout.getAttribute('transform');
      const clipPath = svgedit.utilities.getClipPath(layout);
      const clipPathElem = canvas.copyElem(clipPath.childNodes[0]);

      t && clipPathElem.setAttribute('transform', t);

      clipPathElem.setAttribute('id', getNextId());
      clipPathElem.setAttribute('class', 'layoutClipper');
      clipPathElem.setAttribute('fill', '#000000');
      clipPathElem.setAttribute('stroke', '#FFFFFF');
      clipPathElem.setAttribute('stroke-width', 2);
      clipPathElem.setAttribute('style', getDefaultStyleAttribute('overlay'));

      if (!isBlendModeSupported()) {
        clipPathElem.setAttribute('opacity', '.4');
      }

      return clipPathElem;
    }

    function getLayoutScreen (layoutBox) {
      const layoutScreen = canvas.addSvgElementFromJson({
        element: 'rect',
        curStyles: false,
        attr: {
          x: layoutBox.getAttribute('x'),
          y: layoutBox.getAttribute('y'),
          id: 'layoutScreen',
          width: layoutBox.getAttribute('width'),
          height: layoutBox.getAttribute('height')
        }
      });

      if (isBlendModeSupported()) {
        layoutScreen.setAttribute('fill', '#777777');
      } else {
        layoutScreen.setAttribute('fill', '#FFFFFF');
        layoutScreen.setAttribute('opacity', '.4');
      }

      const transform = layoutBox.getAttribute('transform');

      transform && layoutScreen.setAttribute('transform', transform);

      return layoutScreen;
    }

    function createLayoutOverlay () {
      canvas.addSvgElementFromJson({
        element: 'rect',
        curStyles: false,
        attr: {
          x: 0,
          y: 0,
          id: 'layoutOverlay',
          fill: INKIVE.C.IS_MOBILE
            ? '#545C5D'
            : '#000000',
          width: canvas.contentW,
          height: canvas.contentH,
          opacity: 0.5
        }
      });
    }
  }

  function toggleCanvaOverflow (isOverflowHidden) {
    if (isOverflowHidden) {
      window.$hiddenOverflowContainers = $('#svgcontent > *[clip-path]');
      window.$hiddenOverflowContainers.removeAttr('clip-path');
      $('#copy-paste-panel').hide();
      canvas.runExtensions('disableRuler', {});
    } else if (window.$hiddenOverflowContainers) {
      window.$hiddenOverflowContainers.attr('clip-path', 'url(#clip_canvas)');
      $('#copy-paste-panel').show();
      canvas.runExtensions('enableRuler', {});
    }
  }

  function cropLayoutContent (layoutBox, layoutClipperImage, hasChanges) {
    if (hasChanges) {
      canvas.clearSelection();
      const isVideo = INKIVE.Helpers.elementHelper(layoutBox).isVideo();
      const target = isVideo ? layoutBox.querySelector('image') : layoutBox;
      const dimensions = INKIVE.Helpers.getDimensionsFromElement(layoutClipperImage);

      const angle = svgedit.utilities.getRotationAngle(layoutClipperImage);
      angle && fixRotationCenterOffset(angle, layoutClipperImage, target);

      if (isVideo) {
        cropVideoContent(layoutBox, dimensions);
      } else {
        svgedit.utilities.assignAttributes(layoutBox, dimensions);
      }
    }

    canvas.deleteCurrentLayer();
    canvas.deleteCurrentLayer();

    const layoutOverlay = document.getElementById('layoutOverlay');

    if (!layoutOverlay) {
      return;
    }

    const overlay = layoutOverlay.parentNode;
    overlay.removeChild(overlay.lastChild);

    canvas.call('editor.cropping');
    toggleCanvaOverflow();
    cropCallback && cropCallback();

    function cropVideoContent (target, dimensions) {
      INKIVE.DesignFacade.set(target.id, { clip_path: dimensions, skipHistory: true });
    }

    function fixRotationCenterOffset (angle, layoutClipperImage, layout) {
      let rc = getRotationCenter(layoutClipperImage);
      let bbox = svgedit.utilities.getBBox(layoutClipperImage);
      const oldPoints = INKIVE.Helpers.getTransformPoints(bbox, 0, angle, rc.x, rc.y);

      svgedit.recalculate.cloneTransfromList(layout, layoutClipperImage);

      rc = getRotationCenter(layoutClipperImage);
      bbox = svgedit.utilities.getBBox(layoutClipperImage);
      const newPoints = INKIVE.Helpers.getTransformPoints(bbox, 0, angle, rc.x, rc.y);

      const radians = angle * Math.PI / 180;

      const diffX = oldPoints.tl.x - newPoints.tl.x;
      const diffY = oldPoints.tl.y - newPoints.tl.y;

      const angle2 = Math.atan2(diffY, diffX) - radians;
      const r = Math.sqrt(diffX * diffX + diffY * diffY);
      const x = -r * Math.cos(angle2);
      const y = r * Math.sin(-angle2);

      layoutClipperImage.setAttribute('x', layoutClipperImage.getAttribute('x') - x);
      layoutClipperImage.setAttribute('y', layoutClipperImage.getAttribute('y') - y);

      function getRotationCenter (selected) {
        const transform = selected.getAttribute('transform');
        const regexp = /rotate\(([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?)\)/gi;
        const res = regexp.exec(transform);
        const cx = res
          ? res[3]
          : 0;
        const cy = res
          ? res[5]
          : 0;

        return {
          x: cx,
          y: cy
        };
      }
    }
  }

  function getDataUrl (elem) {
    if (typeof elem === 'undefined') return;
    if (elem?.url) return elem.url;

    return elem.getAttribute('xlink:href') || elem.getAttribute('src');
  }

  function addLayoutImage (layoutElem, elem, imageRatio, skipHistory) {
    const thumbnail = getLayoutBoxThumbnail(layoutElem);
    const dataUrl = getDataUrl(elem);
    const imageScale = imageRatio || 1;
    const elementType = INKIVE.Helpers.elementHelper(layoutElem).isVideo() ? 'video' : 'image';

    if (!dataUrl) {
      canvas.call('advice.show', 'locked-layout-image');
      return;
    }

    const clipPathBB = getLayoutBoxCoord(layoutElem);

    const layout = {
      x: clipPathBB.x,
      y: clipPathBB.y,
      width: clipPathBB.width,
      height: clipPathBB.height
    };

    const eventName = `${elementType}.replace`;
    const imgSize = getFullSize(getElementSize(), layout);
    const frame = INKIVE.Helpers.elementHelper(layoutElem).isSticker() && layoutElem.querySelector('image.subelement');
    if (frame) layoutElem = frame;

    const newAttributes = {
      'xlink:href': dataUrl,
      ...(elementType === 'image'
        ? {
            x: layout.x - imgSize.x,
            y: layout.y - imgSize.y,
            width: imgSize.width * imageScale,
            height: imgSize.height * imageScale
          }
        : {})
    };

    svgedit.utilities.assignAttributes(thumbnail, newAttributes, 100);
    $(thumbnail).data('url', dataUrl);
    thumbnail.setAttribute('data-hash', INKIVE.ImagesFactory.getImageDataHash(thumbnail));
    Object.values(config.smartAssets.attributes).forEach(attr => thumbnail.removeAttribute(attr));

    INKIVE.DesignFacade.trigger(eventName, { id: layoutElem.id, skipHistory });

    function getElementSize () {
      let size = {
        width: elem.width?.baseVal?.value || elem.width || parseFloat(elem.getAttribute('width')) || 0,
        height: elem.height?.baseVal?.value || elem.height || parseFloat(elem.getAttribute('height')) || 0
      };

      if (!size.height || !size.width) {
        const $thumbnail = $(elem).closest('.thumbnail');

        if ($thumbnail.length) {
          size = {
            width: $thumbnail.width(),
            height: $thumbnail.height()
          };
        }
      }

      return size;
    }
  }

  function removeLayoutImage (layoutElem, prvAttr) {
    if (prvAttr) {
      layoutElem.setAttribute('xlink:href', prvAttr.url);
      layoutElem.setAttribute('x', prvAttr.x);
      layoutElem.setAttribute('y', prvAttr.y);
      layoutElem.setAttribute('width', prvAttr.width);
      layoutElem.setAttribute('height', prvAttr.height);

      for (const att of Object.values(config.smartAssets.attributes)) {
        prvAttr[att] && layoutElem.setAttribute(att, prvAttr[att]);
      }

      INKIVE.DesignFacade.trigger('image.replace.skip', { id: layoutElem.id });
    } else {
      setFullSizePlaceholder(layoutElem);
    }
  }

  function deleteLayout (elem) {
    $(elem).remove();

    const $clip = $('#clip_' + elem.id);
    if ($clip.length) {
      $clip.remove();
    }
  }

  function setFullSizePlaceholder (elem) {
    const clipPathBB = getLayoutBoxCoord(elem);
    const imgFullSize = getFullSize(placeholderSize, clipPathBB);

    elem.setAttribute('xlink:href', placeholder);
    elem.setAttribute('x', clipPathBB.x - imgFullSize.x);
    elem.setAttribute('y', clipPathBB.y - imgFullSize.y);
    elem.setAttribute('width', imgFullSize.width);
    elem.setAttribute('height', imgFullSize.height);
  }

  // It calculate layout position (using in touch drag & drop)
  function layoutChecker (x, y) {
    const layoutList = $('.layoutBox');
    let clipPathSize = {};
    zoom = canvas.getZoom();

    for (let i = layoutList.length - 1; i >= 0; i--) {
      clipPathSize = getLayoutBoxCoord(layoutList[i]);

      if (clipPathSize.x * zoom < x &&
        x < (clipPathSize.x + clipPathSize.width) * zoom &&
        clipPathSize.y * zoom < y &&
        y < (clipPathSize.y + clipPathSize.height) * zoom) {
        return layoutList[i];
      }
    }
  }

  function addLayoutBox (opts) {
    canvas.clearSelection();
    const elem = opts.elem;
    const clipPathBB = opts.clipPathBB;

    clipPathBB.x = Math.floor4(clipPathBB.x);
    clipPathBB.y = Math.floor4(clipPathBB.y);
    clipPathBB.width = Math.floor4(clipPathBB.width);
    clipPathBB.height = Math.floor4(clipPathBB.height);

    const imgFullSize = getFullSize(placeholderSize, {
      x: clipPathBB.x,
      y: clipPathBB.y,
      width: clipPathBB.width,
      height: clipPathBB.height
    });

    const id = opts.background
      ? config.background.image
      : canvas.getNextId();

    const attr = {
      x: clipPathBB.x - imgFullSize.x,
      y: clipPathBB.y - imgFullSize.y,
      id,
      width: imgFullSize.width,
      height: imgFullSize.height,
      class: 'layoutBox element',
      'clip-path': 'url(#clip_' + id + ')',
      'xlink:href': opts['xlink:href'] || placeholder
    };

    Object.values(config.smartAssets.attributes).forEach(key => {
      if (opts[key]) {
        attr[key] = opts[key];
      }
    });

    const layoutBox = canvas.addSvgElementFromJson({
      attr,
      element: 'image',
      curStyles: false
    });

    setLayoutBoxCoord(layoutBox.id, opts.clipPathBB);
    addLayoutDefs(layoutBox.id, elem);

    opts.background && $(layoutBox).detach().appendTo('g.background');
    return layoutBox;
  }

  function addVideoLayoutBox (opts) {
    canvas.clearSelection();
    const {
      element,
      clipPathBB
    } = opts;
    const clipPathId = canvas.getNextId();
    const clipPathElement = canvas.addSvgElementFromJson({
      element: 'rect',
      curStyles: false,
      attr: {
        x: clipPathBB.x,
        y: clipPathBB.y,
        id: clipPathId,
        width: clipPathBB.width,
        height: clipPathBB.height
      }
    });
    const clipPathAttribute = `url(#clip_${clipPathId})`;
    const videoThumb = element.querySelector('image');

    element.setAttribute('clip-path', clipPathAttribute);
    videoThumb.setAttribute('clip-path', clipPathAttribute);

    setLayoutBoxCoord(element, opts.clipPathBB);
    setLayoutBoxCoord(videoThumb, opts.clipPathBB);
    addLayoutDefs(clipPathId, clipPathElement);

    return element;
  }

  function validationlayoutDefsClip (layoutDefsClip) {
    const id = layoutDefsClip.id;
    const len = layoutDefsClip.childNodes.length;

    const elemId = id.replace('clip_', '');
    let transform = null;

    for (let i = 0; i < len; i++) {
      transform = layoutDefsClip.childNodes[i].getAttribute('transform');
      layoutDefsClip.childNodes[i].removeAttribute('transform');
    }

    const elem = $('#' + elemId).get(0);
    if (transform && elem) elem.setAttribute('transform', transform);
  }

  function addLayoutDefs (id, elem) {
    const svgcontent = $('#svgcontent').get(0);
    let layoutDefs = $('#svgcontent #layout_defs').get(0);

    if (!layoutDefs) {
      layoutDefs = window.document.createElementNS(NS.SVG, 'defs');
      layoutDefs.setAttribute('id', 'layout_defs');
    }

    $('#clip_' + id).remove();
    const layoutDefsClip = window.document.createElementNS(NS.SVG, 'clipPath');
    layoutDefsClip.setAttribute('id', 'clip_' + id);

    layoutDefs.appendChild(layoutDefsClip);
    elem.setAttribute('class', 'layoutClipper');
    layoutDefsClip.appendChild(elem);

    svgcontent.insertBefore(layoutDefs, svgcontent.firstChild);
    validationlayoutDefsClip(layoutDefsClip);
  }

  function setTransform (layoutId, val) {
    val = parseFloat(val);
    const elem = $('#' + layoutId).get(0);
    const bbox = svgedit.utilities.getBBox(elem);
    const cx = bbox.x + bbox.width / 2;
    const cy = bbox.y + bbox.height / 2;
    const tlist = svgedit.transformlist.getTransformList(elem);

    // only remove the real rotational transform if present (i.e. at index=0)
    if (tlist.numberOfItems > 0) {
      const xform = tlist.getItem(0);
      if (xform.type === 4) {
        tlist.removeItem(0);
      }
    }
    // find R_nc and insert it
    if (val !== 0) {
      const center = svgedit.math.transformPoint(cx, cy, svgedit.math.transformListToTransform(tlist).matrix);
      const rNc = $('#svgroot').get(0).createSVGTransform();
      rNc.setRotate(val, center.x, center.y);
      if (tlist.numberOfItems) {
        tlist.insertItemBefore(rNc, 0);
      } else {
        tlist.appendItem(rNc);
      }
    } else if (tlist.numberOfItems === 0) {
      elem.removeAttribute('transform');
    }
  }

  function moveLayout (layoutBox, dx, dy) {
    dx = parseFloat(dx);
    dy = parseFloat(dy);

    layoutBox.setAttribute('x', parseFloat(layoutBox.getAttribute('x')) + dx);
    layoutBox.setAttribute('y', parseFloat(layoutBox.getAttribute('y')) + dy);

    const elem = $('#clip_' + layoutBox.id).get(0).childNodes[0];
    const xform = svgroot.createSVGTransform();
    const tlist = svgedit.transformlist.getTransformList(elem);

    xform.setTranslate(dx, dy);

    tlist.numberOfItems
      ? tlist.replaceItem(xform, 0)
      : tlist.appendItem(xform);

    const bb = getLayoutBoxCoord(layoutBox);

    canvas.recalculateDimensions(elem, bb);
    bb.x += dx;
    bb.y += dy;

    setLayoutBoxCoord(layoutBox.id, bb);
  }

  function moveLayoutClipperImage (selected, dx, dy) {
    let cx;
    let cy;
    const angle = svgedit.utilities.getRotationAngle(selected);
    const clipImageBB = svgedit.utilities.getBBox(selected);
    const clipPathBB = getLayoutBoxCoord(selected);

    const oldId = selected.dataset.oldId;
    const oldElement = document.getElementById(oldId);
    const clipPath = svgedit.utilities.getClipPath(oldElement)?.childNodes[0];
    const clipPathAngle = clipPath
      ? svgedit.utilities.getRotationAngle(clipPath) || angle
      : angle;

    if (angle) {
      const transform = selected.getAttribute('transform');
      const regexp = /rotate\(([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?)\)/gi;
      const res = regexp.exec(transform);

      cx = res
        ? res[3]
        : 0;
      cy = res
        ? res[5]
        : 0;
    }

    const _path = INKIVE.Helpers.getTransformPoints(clipPathBB, 0, clipPathAngle);
    const _image = INKIVE.Helpers.getTransformPoints(clipImageBB, 0, angle, cx, cy);

    if (exceedsTopFrontier()) {
      restrictTopOncoming();
    } else if (exceedsBottomFrontier()) {
      restrictBottomOncoming();
    } else if (exceedsLeftFrontier()) {
      restrictLeftOncoming();
    } else if (exceedsRightFrontier()) {
      restrictRightOncoming();
    }

    const scaleProperties = svgedit.utilities.getScale(selected);

    if (scaleProperties.scale) {
      dx = dx * scaleProperties.scale.matrix.a;
      dy = dy * scaleProperties.scale.matrix.d;
    }

    return {
      dx,
      dy
    };

    function exceedsTopFrontier () {
      return _pointToLineDistance(_image.tl, _image.tr, _path.tl, dx, dy) > 0;
    }

    function exceedsBottomFrontier () {
      return _pointToLineDistance(_image.bl, _image.br, _path.bl, dx, dy) < 0;
    }

    function exceedsLeftFrontier () {
      return _pointToLineDistance(_image.bl, _image.tl, _path.bl, dx, dy) > 0;
    }

    function exceedsRightFrontier () {
      return _pointToLineDistance(_image.br, _image.tr, _path.br, dx, dy) < 0;
    }

    function restrictTopOncoming () {
      if (exceedsLeftFrontier()) {
        dx = _path.tl.x - _image.tl.x;
        dy = _path.tl.y - _image.tl.y;
      }
      if (exceedsRightFrontier()) {
        dx = _path.tr.x - _image.tr.x;
        dy = _path.tr.y - _image.tr.y;
      } else {
        const intersection = getIntersection(
          {
            p1: _path.tl,
            p2: _path.tr
          },
          {
            p1: {
              x: _image.tl.x,
              y: _image.tl.y
            },
            p2: {
              x: _image.tl.x + dx,
              y: _image.tl.y + dy
            }
          }
        );

        if (intersection && Math.round(intersection.y) !== Math.round(_image.tl.y)) {
          dx = intersection.x - _image.tl.x;
        }

        dy = intersection
          ? intersection.y - _image.tl.y
          : _path.tl.y - _image.tl.y;
      }
    }

    function restrictBottomOncoming () {
      if (exceedsLeftFrontier()) {
        dx = _path.bl.x - _image.bl.x;
        dy = _path.bl.y - _image.bl.y;
      }
      if (exceedsRightFrontier()) {
        dx = _path.br.x - _image.br.x;
        dy = _path.br.y - _image.br.y;
      } else {
        const intersection = getIntersection(
          {
            p1: _path.bl,
            p2: _path.br
          },
          {
            p1: {
              x: _image.bl.x,
              y: _image.bl.y
            },
            p2: {
              x: _image.bl.x + dx,
              y: _image.bl.y + dy
            }
          }
        );

        if (intersection && Math.round(intersection.y) !== Math.round(_image.bl.y)) {
          dx = intersection.x - _image.bl.x;
        }

        dy = intersection
          ? intersection.y - _image.bl.y
          : _path.bl.y - _image.bl.y;
      }
    }

    function restrictLeftOncoming () {
      const intersection = getIntersection(
        {
          p1: _path.bl,
          p2: _path.tl
        },
        {
          p1: {
            x: _image.tl.x,
            y: _image.tl.y
          },
          p2: {
            x: _image.tl.x + dx,
            y: _image.tl.y + dy
          }
        }
      );

      if (intersection && Math.round(intersection.x) !== Math.round(_image.tl.x)) {
        dy = intersection.y - _image.tl.y;
      }

      dx = intersection
        ? intersection.x - _image.tl.x
        : _path.bl.x - _image.tl.x;
    }

    function restrictRightOncoming () {
      const intersection = getIntersection(
        {
          p1: _path.br,
          p2: _path.tr
        },
        {
          p1: {
            x: _image.tr.x,
            y: _image.tr.y
          },
          p2: {
            x: _image.tr.x + dx,
            y: _image.tr.y + dy
          }
        }
      );

      if (intersection && Math.round(intersection.x) !== Math.round(_image.tr.x)) {
        dy = intersection.y - _image.tr.y;
      }

      dx = intersection
        ? intersection.x - _image.tr.x
        : _path.br.x - _image.tr.x;
    }

    function getIntersection (l1, l2) {
      const x12 = l1.p1.x - l1.p2.x;
      const x34 = l2.p1.x - l2.p2.x;
      const y12 = l1.p1.y - l1.p2.y;
      const y34 = l2.p1.y - l2.p2.y;

      const c = x12 * y34 - y12 * x34;

      if (Math.abs(c) < 0.01) {
        return false;
      } else {
        const a = l1.p1.x * l1.p2.y - l1.p1.y * l1.p2.x;
        const b = l2.p1.x * l2.p2.y - l2.p1.y * l2.p2.x;

        return {
          x: (a * x34 - b * x12) / c,
          y: (a * y34 - b * y12) / c
        };
      }
    }

    function _pointToLineDistance (v1, v2, p, dx, dy) {
      dx = dx || 0;
      dy = dy || 0;

      const v1x = v1.x + dx;
      const v2x = v2.x + dx;
      const v1y = v1.y + dy;
      const v2y = v2.y + dy;

      const normalLength = Math.sqrt(Math.pow(v2x - v1x, 2) + Math.pow(v2y - v1y, 2));
      return ((v2x - v1x) * (v1y - p.y) - (v1x - p.x) * (v2y - v1y)) / normalLength;
    }
  }
  function generateOutsideCanvasSelectionBox (elem) {
    if (
      !elem ||
      INKIVE.Helpers.isElementInCanvas(elem) ||
      INKIVE.Helpers.isElementPartiallyInCanvas(elem) ||
      !elem.parentElement?.classList?.contains('main')
    ) return;
    $('#selector-rect-' + elem.id).remove();

    let parentElement = $('#outsideCanvasSelectorGroup')[0];
    const isParentElementPresent = _.isObject(parentElement);
    const $selectorParentGroup = $('#selectorParentGroup');
    const transform = $selectorParentGroup.attr('transform');

    if (!isParentElementPresent) {
      parentElement = canvas.addSvgElementFromJson({
        element: 'g',
        attr: {
          id: 'outsideCanvasSelectorGroup',
          transform,
          style: 'pointer-events:auto'
        }
      });
    } else {
      $(parentElement).attr('transform', transform);
    }

    const selector = canvas.selectorManager.requestSelector(elem);
    selector.resize(true);
    _.include(canvas.getSelectedElems(), elem) || canvas.selectorManager.releaseSelector(elem);

    const $selectorGroup = $selectorParentGroup.find('[data-element-id=' + elem.id + ']');
    if (!$selectorGroup.length) {
      return;
    }

    const g = canvas.addSvgElementFromJson({
      element: 'g',
      attr: {
        id: 'selector-rect-' + elem.id,
        transform: $selectorGroup.attr('transform'),
        style: 'pointer-events:all'
      }
    });
    const path = canvas.addSvgElementFromJson({
      element: 'path',
      attr: {
        'data-related-id': '#' + elem.id,
        fill: 'none',
        stroke: '#AAAAAA',
        'stroke-width': '2',
        'stroke-dasharray': '2',
        class: 'outside-canvas-selection-box',
        d: $selectorGroup.find('path').attr('d')
      }
    });

    g.appendChild(path);
    parentElement.appendChild(g);

    isParentElementPresent || $('#svgpanel').prepend(parentElement);
  }

  function removeImageQualityBox (opts) {
    $('#image-quality-box-group').remove();
  }

  function generateImageQualityBox (opts) {
    let elem = (opts.elem && document.getElementById(opts.elem.id)) || opts.elem;
    const isBackground = $(elem).parent().is('.background');
    const isAcceptable = opts.isAcceptable;
    let parentElement = $('#image-quality-box-group')[0];
    const isParentElementPresent = _.isObject(parentElement);
    const $selectorParentGroup = $('#selectorParentGroup');
    const transform = $selectorParentGroup.attr('transform');
    const isOrderPrintShown = $('#svgcontent').is('.order-print-active');

    if (!isParentElementPresent) {
      parentElement = canvas.addSvgElementFromJson({
        element: 'g',
        attr: {
          id: 'image-quality-box-group',
          transform,
          style: 'pointer-events:auto'
        }
      });
    } else {
      $(parentElement).attr('transform', transform);
    }

    isOrderPrintShown || $(parentElement).one('click', removeImageQualityBox);

    if (isBackground) {
      elem = $(elem).siblings('rect')[0];
      elem.id = 'rect-background';
    }

    const selector = canvas.selectorManager.requestSelector(elem);
    selector.resize(true);

    const $selectorGroup = $selectorParentGroup.find('[data-element-id=' + elem.id + ']');
    if (!$selectorGroup.length) {
      return;
    }

    const g = canvas.addSvgElementFromJson({
      element: 'g',
      attr: {
        id: 'image-quality-box-' + elem.id,
        transform: $selectorGroup.attr('transform')
      }
    });
    const path = canvas.addSvgElementFromJson({
      element: 'path',
      attr: {
        fill: 'none',
        stroke: '#5F99FF',
        'stroke-width': '2',
        class: 'image-quality-box ' + (isAcceptable
          ? 'high-quality'
          : ''),
        d: $selectorGroup.find('path').attr('d'),
        'data-id': isBackground
          ? 'background'
          : elem.id
      }
    });

    const xPosition = path.getBBox().x + path.getBBox().width;
    const yPosition = path.getBBox().y;

    const qualityCheck = canvas.addSvgElementFromJson({
      element: 'circle',
      attr: {
        fill: (isAcceptable
          ? '#7AC142'
          : '#FF1F29'),
        r: 10,
        cx: xPosition,
        cy: yPosition
      }
    });

    const qualityCheckSign = canvas.addSvgElementFromJson({
      element: 'path',
      attr: {
        fill: '#FFFFFF',
        stroke: '#FFFFFF',
        'stroke-width': 1,
        d: isAcceptable
          ? checkPath
          : exclamationPath,
        transform: 'translate(' + xPosition + ',' + yPosition + ')'
      }
    });

    g.appendChild(path);
    g.appendChild(qualityCheck);
    g.appendChild(qualityCheckSign);
    parentElement.appendChild(g);

    canvas.selectorManager.releaseSelector(elem);
    isParentElementPresent || $('#svgpanel').prepend(parentElement);
  }

  function isPlaceHolder (url) {
    return INKIVE.Helpers.getCORSSecureUrl(url) === INKIVE.Helpers.getCORSSecureUrl(placeholder);
  }

  function checkImageSize (elem, skipSelection) {
    const $elem = $(elem);
    const url = $elem.attr('xlink:href');

    if (!url || _.includes(checkedImages, elem.id)) {
      return;
    }

    const elemHeight = $elem.attr('height');
    const elemRatio = elemHeight / $elem.attr('width');
    const img = new Image();

    img.onload = function () {
      checkedImages.push(elem.id);
      const imgRatio = this.height / this.width;
      if (Math.abs(imgRatio - elemRatio) > 0.01) {
        const newHeight = $elem.attr('width') * imgRatio;
        const heightDiff = (elemHeight - newHeight) / 2;

        const clipPath = svgedit.utilities.getClipPath(elem);
        if (clipPath) {
          const rect = $(clipPath).find('rect');
          const rectHeight = rect.attr('height') - heightDiff;

          if ($elem.attr('y') > rect.attr('y') && rectHeight > 0) {
            $elem.attr('height', newHeight);
            $elem.attr('y', $elem.attr('y') + heightDiff);

            rect.attr('height', rectHeight);
            rect.attr('y', rect.attr('y') + heightDiff);
          }
        }

        skipSelection || canvas.selectOnly([elem]);
      }
    };

    img.src = url;
  }

  function getLayout (opts) {
    return opts.mouse_x && opts.mouse_y
      ? layoutChecker(opts.mouse_x, opts.mouse_y)
      : tool.editor.canvas.getSelectedElems()[0];
  }

  function checkRestricted (elementType, id) {
    if (INKIVE.RestrictionsFacade.isRestrictedDesign()) return false;

    const restriction = elementType === 'image' ? 'image_content' : 'video_replace';
    return INKIVE.RestrictionsFacade.getElementRestriction(id, restriction) === false;
  }

  function savePreviousAttribute (layout) {
    const subElement = layout.querySelector('.subelement');
    const layoutElement = subElement && !layout.getAttribute('xlink:href')
      ? subElement
      : layout;

    const thumbnail = getLayoutBoxThumbnail(layoutElement);
    const layoutPrvAttr = {
      x: thumbnail.getAttribute('x'),
      y: thumbnail.getAttribute('y'),
      url: thumbnail.getAttribute('xlink:href'),
      width: thumbnail.getAttribute('width'),
      height: thumbnail.getAttribute('height')
    };

    Object.keys(config.smartAssets.attributes).forEach(key => {
      const input = thumbnail.getAttribute(key);
      if (input) layoutPrvAttr[key] = input;
    });

    canvas._t.layout_prvElem = layout;
    canvas._t.layout_prvAttr = layoutPrvAttr;
  }

  function getOptionElement (options) {
    const optionsElement = options.elem || document.createElement('image');

    optionsElement.setAttribute('src', options.source);
    optionsElement.setAttribute('width', options.width);
    optionsElement.setAttribute('height', options.height);

    return optionsElement;
  }

  function canReposition (element) {
    const elementDetails = INKIVE.Helpers.elementHelper(element);
    const image = elementDetails.isSticker()
      ? element.querySelector('image')
      : element;
    if (!image) return false;
    if (
      INKIVE.Helpers.elementHelper(element).isVideo() &&
      INKIVE.RestrictionsFacade.initialized &&
      !INKIVE.RestrictionsFacade.canChange(element, 'position')
    ) {
      return false;
    }
    const hasPlaceholder =
      (image.getAttribute('xlink:href') || '').indexOf('imageplaceholder') >
      -1;
    if (hasPlaceholder) return false;

    return image.classList.contains('layoutBox');
  }

  return {
    isEmptyLayout: function (opts) {
      let isEmptyLayoutbox = $(opts.layoutBox).hasClass('layoutBox');
      isEmptyLayoutbox &= isPlaceHolder(opts.layoutBox.getAttribute('xlink:href'));

      return isEmptyLayoutbox;
    },

    setFullSizePlaceholder: function (opts) {
      setFullSizePlaceholder(opts.layoutBox);
    },

    addLayoutBox: function (opts) {
      return addLayoutBox(opts);
    },

    addVideoLayoutBox: function (opts) {
      return addVideoLayoutBox(opts);
    },

    setLayoutBoxCoord: function (opts) {
      setLayoutBoxCoord(opts.layoutBox, opts.bbox);
    },

    getLayoutBoxCoord: function (opts) {
      return getLayoutBoxCoord(opts.layoutBox);
    },

    showLayoutClipper: function (opts) {
      showLayoutClipper(opts.layout, opts.callback);
    },

    cropLayoutContent: function (opts) {
      const layout = opts.layout;
      const backgroundId = $('svg > g.background image').attr('id');
      const isBackground = $(layout).parent().is('.background') || $(layout).attr('data-old-id') === backgroundId;

      if (layout && layout.getAttribute('class') && !isBackground) {
        cropLayoutContent(layout, opts.elem, opts.hasChanges);
      }
    },

    // copyLayout: function(opts) {
    //  return copyLayout(opts.elem);
    // },

    moveLayout: function (opts) {
      return moveLayout(opts.elem, opts.dx, opts.dy);
    },

    moveLayoutClipperImage: function (opts) {
      return moveLayoutClipperImage(opts.selected, opts.dx, opts.dy);
    },

    setLayout: function (opts) {
      const triggerImagesLoading = typeof opts.triggerImagesLoading === 'undefined'
        ? true
        : opts.triggerImagesLoading;

      setLayout(opts.defs, opts.content, triggerImagesLoading, opts.keep);
    },

    addLayoutImage: function (opts) {
      addLayoutImage(opts.elem, opts.data, undefined, opts.skipHistory);
    },

    removeLayoutImage: function (opts) {
      removeLayoutImage(opts.elem, opts.attr);
    },

    deleteLayout: function (opts) {
      if (isPlaceHolder(opts.elem.getAttribute('xlink:href')) ||
        INKIVE.RestrictionsFacade.isForbiddenElement(opts.elem)) {
        deleteLayout(opts.elem);
        return null;
      } else {
        setFullSizePlaceholder(opts.elem);
        return opts.elem;
      }
    },

    overLayoutImage: function (opts) {
      const layout = opts.mouse_x && opts.mouse_y
        ? layoutChecker(opts.mouse_x, opts.mouse_y)
        : tool.editor.canvas.getSelectedElems()[0];

      if (layout && opts.selection && opts.selection.id !== layout.getAttribute('id')) {
        return;
      }

      if (canvas._t.layout_prvElem === layout) return layout;

      if (canvas._t.layout_prvElem) {
        removeLayoutImage(getLayoutBoxThumbnail(canvas._t.layout_prvElem), canvas._t.layout_prvAttr);

        canvas._t.layout_prvElem = null;
        canvas._t.layout_prvAttr = null;

        setOpacity(opts.elem, 1.0);
      }

      if (layout && !canvas._t.layout_prvElem) {
        const elementType = INKIVE.Helpers.elementHelper(layout).isVideo() ? 'video' : 'image';

        if (INKIVE.RestrictionsFacade.isRestrictedDesign()) {
          const { id } = layout;
          const restriction = elementType === 'image' ? 'image_content' : 'video_replace';
          const isRestricted = INKIVE.RestrictionsFacade.getElementRestriction(id, restriction) === false;
          if (isRestricted) return;

          const restrictedSources = INKIVE.RestrictionsFacade.getElementRestrictions(id, 'source');
          const hasRestrictedSource = restrictedSources && restrictedSources.length;
          if (hasRestrictedSource) return;
        }

        if (canvas.getMode().match('replace-') && layout !== canvas.getSelectedElems()[0]) {
          return null;
        }

        if (elementType === opts.type) {
          const subelement = layout.querySelector('.subelement');
          const layoutElement = subelement && !layout.getAttribute('xlink:href')
            ? subelement
            : layout;

          const thumbnail = getLayoutBoxThumbnail(layoutElement);
          const layoutPrvAttr = {
            x: thumbnail.getAttribute('x'),
            y: thumbnail.getAttribute('y'),
            url: thumbnail.getAttribute('xlink:href'),
            width: thumbnail.getAttribute('width'),
            height: thumbnail.getAttribute('height')
          };

          Object.keys(config.smartAssets.attributes).forEach(key => {
            const input = thumbnail.getAttribute(key);
            if (input) layoutPrvAttr[key] = input;
          });

          canvas._t.layout_prvElem = layout;
          canvas._t.layout_prvAttr = layoutPrvAttr;

          addLayoutImage(layout, opts.elem, opts.imageRatio, opts.skipHistory);

          setOpacity(opts.elem, 0.3);
        }
      }

      return layout;

      function setOpacity (elem, val) {
        elem.tagName === 'image'
          ? svgedit.utilities.assignAttributes(elem, { opacity: val }, 100)
          : $(elem).css('opacity', val);
      }
    },

    overLayoutImageUrl: function (options) {
      if (!options.source || !options.height || !options.width) return;

      const layout = getLayout(options);
      const id = layout?.id;

      if (layout && options.selection && id !== options.selection.id) return;
      if (canvas._t.layout_prvElem === layout) return layout;

      if (canvas._t.layout_prvElem) {
        removeLayoutImage(getLayoutBoxThumbnail(canvas._t.layout_prvElem), canvas._t.layout_prvAttr);

        canvas._t.layout_prvElem = null;
        canvas._t.layout_prvAttr = null;
      }

      if (layout && !canvas._t.layout_prvElem) {
        const elementType = INKIVE.Helpers.elementHelper(layout).isVideo() ? 'video' : 'image';
        const isRestricted = checkRestricted(elementType, id);

        if (isRestricted) return;

        const isLayoutSelectedElement = layout === canvas.getSelectedElems()[0];
        const isReplaceMode = canvas.getMode().match('replace-');

        if (isReplaceMode && !isLayoutSelectedElement) return null;

        if (elementType !== options.type) return layout;

        savePreviousAttribute(layout);
        const optionsElement = getOptionElement(options);
        addLayoutImage(layout, optionsElement, options.imageRatio, options.skipHistory);
      }

      return layout;
    },

    /**
     * Image clipper
     */
    dblClick: function (opts) {
      const evt = opts.event;
      const $openClipper = $('.layoutClipperImage');
      const mouseTarget = opts.mouse_target;
      const isAllowedVideo = INKIVE.Helpers.elementHelper(mouseTarget).isVideo() && INKIVE.Helpers.elementHelper(mouseTarget).hasLayoutBox();
      const isLocked = mouseTarget.classList?.contains('locked');
      const hasPlaceholderFrame = INKIVE.Helpers.elementHelper(mouseTarget).hasPlaceholderFrame() && !isLocked;
      const placeHolderImage = hasPlaceholderFrame && mouseTarget.querySelector('image');
      const hasLayoutBoxAvailable = hasPlaceholderFrame
        ? placeHolderImage && INKIVE.Helpers.elementHelper(placeHolderImage).hasLayoutBox() && !isLocked
        : INKIVE.Helpers.elementHelper(mouseTarget).hasLayoutBox() && !isLocked;

      evt.preventDefault();
      evt.stopPropagation();

      $openClipper.trigger('dblclick');

      if (!mouseTarget || $openClipper.length || !hasLayoutBoxAvailable || !canReposition(mouseTarget)) {
        return;
      }

      const isAllowedImage = mouseTarget.tagName === 'image' &&
        !(mouseTarget.getAttribute('xlink:href').indexOf('imageplaceholder') >= 0) &&
        mouseTarget.dataset.externalSource !== INKIVE.C.SHUTTERSTOCK;

      if (isAllowedImage || isAllowedVideo) {
        INKIVE.EditorFacade.handle(mouseTarget.id, 'crop');
      } else if (hasPlaceholderFrame && placeHolderImage) {
        const href = placeHolderImage.getAttribute('xlink:href');
        const isDefaultImage = href && href.indexOf('imageplaceholder') >= 0;
        isDefaultImage || INKIVE.EditorFacade.handle(placeHolderImage.getAttribute('id'), 'crop');
      }
    },

    mouseDown: function (opts) {
      const selected = canvas.getSelectedElems()[0];

      if (selected) {
        const islayoutClipperImage = $(selected).hasClass('layoutClipperImage');
        const canRotate = !islayoutClipperImage && INKIVE.RestrictionsFacade.canChange(selected, 'rotation');

        canRotate || $('#selectorGrip_rotateconnector, #selectorGrip_rotate').hide();

        if ($(selected).hasClass('image') && canvas.getMode() === 'select') {
          // Simple Object {}
          canvas._t.layout_prvElem = null;
          canvas._t.layout_prvAttr = null;
        }
      } else if (INKIVE.C.IS_MOBILE && $('.clipperImage .layoutClipperImage').length) {
        const layout = $('.clipperImage .layoutClipperImage').get(0);
        if (layout && layout.getAttribute('class') && layout.getAttribute('class').indexOf('background') === -1) {
          cropLayoutContent(layout, layout, false);
        }
      }
      $('#image-quality-box-group').remove();
    },

    mouseMove: function (opts) {
      const selected = canvas.getSelectedElems()[0];

      $(selected).trigger('move');
      if (canvas.getMode() === 'select' &&
        selected &&
        selected.tagName === 'image' &&
        $(selected).is('.image') &&
        !$(selected).is('.logo') &&
        !$(selected).is('.icon') &&
        !$(selected).is('.video')) {
        this.overLayoutImage({
          elem: selected,
          mouse_x: opts.mouse_x,
          mouse_y: opts.mouse_y
        });
      }
    },

    mouseUp: function (opts) {
      const selectedElements = canvas.getSelectedElems();
      const selected = selectedElements[0];

      if (canvas.getMode() === 'select' &&
        selected &&
        selected.tagName === 'image' &&
        $(selected).hasClass('image') &&
        canvas._t.layout_prvElem) {
        svgedit.utilities.assignAttributes(selected, {
          opacity: 1.0
        });

        canvas.deleteSelectedElements();
        canvas._t.layout_prvElem = null;
        canvas._t.layout_prvAttr = null;
      }
    },

    recalculateOutsideCanvasSelectionBox: function () {
      const outsideCanvasSelectorGroup = document.querySelector('#outsideCanvasSelectorGroup');
      outsideCanvasSelectorGroup && outsideCanvasSelectorGroup.remove();
      const $allElements = $(canvas.getSvgContent()).find('.main').find('.element');
      $allElements.each(function (idx, elem) {
        generateOutsideCanvasSelectionBox(elem);
      });
    },

    startResize: function (opts) {
      opts && opts.elem && opts.elem.id && $('#selector-rect-' + opts.elem.id).hide();
    },

    endResize: function (opts) {
      opts && opts.elem && generateOutsideCanvasSelectionBox(opts.elem);
    },

    startMove: function (opts) {
      if (!opts && !opts.mouseTarget && !opts.selectedElement) {
        return;
      }

      const elements = _.contains(opts.selectedElements, opts.mouseTarget)
        ? opts.selectedElements
        : [opts.mouseTarget];

      _.each(elements, _.bind(function (elem) {
        this.startResize({ elem });
      }, this));
    },

    endMove: function (opts) {
      this.endResize(opts);
    },

    startRotate: function (opts) {
      this.startResize(opts);
    },

    endRotate: function (opts) {
      this.endResize(opts);
    },

    zoomChanged: function () {
      zoom = canvas.getZoom();
      const $svgcontent = $('#svgcontent');
      const recalculateImageQuality = $('#image-quality-box-group').length && $svgcontent.find('.main').length;

      this.recalculateOutsideCanvasSelectionBox();
      removeImageQualityBox();

      recalculateImageQuality && INKIVE.EditorFacade.handle('printing', 'image_quality_check', { show: true });
    },

    selectedChanged: function (opts) {
      if (!opts || !opts.elems || opts.elems.length !== 1) { return; }

      const $elem = $(opts.elems[0]);

      if ($elem.is('image')) {
        this.fixImageSize({ elem: $elem[0] });
      }
    },

    fixImageSize: function (opts) {
      const elem = opts.elem;
      const skipSelection = opts.skipSelection;

      if ($(elem).data('external_source') === INKIVE.C.SHUTTERSTOCK) return;

      checkImageSize(elem, skipSelection);
    },

    generateImageQualityBox: function (opts) {
      generateImageQualityBox(opts);
    },

    removeImageQualityBox: function (opts) {
      removeImageQualityBox(opts);
    }
  };
};
